import React from 'react';

const Trading = () => {
  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%)',
      padding: '2rem 1rem',
    }}>
      <div className="page-wrapper">
        <div className="page-hero">
          <h1>📈 Trading</h1>
          <p>Master the art of trading and financial markets.</p>
        </div>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
        }}>
          <p>Trading content will be rendered here</p>
        </div>
      </div>
    </div>
  );
};

export default Trading;
